import React from 'react';

import { Auth } from 'aws-amplify';
import { I18n } from '@aws-amplify/core';
import {
  AmplifyTheme,
  ForgotPassword,
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  InputRow,
  ButtonRow,
  MessageRow,
  Link
} from 'aws-amplify-react';
import axios from 'axios';

import {SESSION_INIT_URL, TERM_VER} from '../../configures/val.js'
import {authConfig} from '../../configures/awsConfig.js'
import EnterPassword from './enterPassword.js';
import LogoArea from './logoarea.js';
import LapDialog from '../util/laplaceDialog.js';
import getHrefByLocaleLaplaceidQa from '../util/getHrefByLocale.js';
import checkTermsVer from '../util/checkTermsVer.js';

const errorColor = {
  color: "#858585",
};
const okColor = {
  color: "#ff8b1a",
};
export default class MyForgotPassword extends ForgotPassword {
  constructor(props) {
    super(props);

    this.send = this.send.bind(this);
    this.submit = this.submit.bind(this);
    this.userDataForCheckTerm = {};

    this._validAuthStates = ['forgotPassword'];
    this.isSendCodeDisabled = true;

    this.state = {
      delivery: null,
      isDisabled : true,
      paramPassword:"",
      mailAddress: "",
      errorStr: "",
      open: false,
      resendErrOpen: false,
      codeErrorStr: '',
      resendErrStr: '',
      termVerError: false,
      passState: {
        isNumOk: false,
        isLowerOk: false,
        isUpperOk: false,
        isOverOk: false,
      },
    };
    this.inputs = {
      code: ''
    };
  }
  toClose = () => {
    this.setState({ open: false });
  }
  resendErrOpenClose = () => {
    this.setState({ resendErrOpen: false });
  }
  send() {
    const { username } = this.inputs;
    if (!Auth || typeof Auth.forgotPassword !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    Auth.forgotPassword(username).then(data => {
      this.setState({
        open: true,
        delivery: data.CodeDeliveryDetails
      });
    })
    .catch(err => {
      const errMessage = err.message ? err.message : err;
      const errStr = I18n.get(this.transErrorStr(errMessage));
      console.log('forgot send err');
      console.log(err);
      this.setState({
        resendErrOpen: true,
        resendErrStr: errStr,
      });
    });
  }

  checkIsNeedPersonalData = (attr) => {
    for(let i=0; i<attr.length; i++) {
      if((attr[i].Name === "custom:account_state") && (attr[i].Value === "temporary")) {
        return true;
      }
    }
    return false;
  }
  transErrorStr = (errmes) => {
    if ('Username/client id combination not found.' === errmes) {
      return 'Entered Laplace ID is not registered';
    }
    return errmes;
  }
  async submit(that) {
    const { username, code } = this.inputs;
    if (!Auth || typeof Auth.forgotPasswordSubmit !== 'function') {
      throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
    }
    let result = '';
    let user = '';
    try {
      await Auth.forgotPasswordSubmit(username, code, this.state.paramPassword);
      user = await Auth.signIn(this.state.mailAddress, this.state.paramPassword);
      result = await Auth.userAttributes(user);
    } catch (err) {
      console.log('err:: Auth');
      console.log(err);
      const errStr = this.transErrorStr(err.message);
      this.setState({
        codeErrorStr : I18n.get(errStr)
      });
    }
    // 個人情報に漏れがないかをチェックする
    if (this.checkIsNeedPersonalData(result)) {
      await Auth.signOut();
      const datum = {
        user: user,
        userData: {
          username: this.state.mailAddress,
          pw: this.state.paramPassword
        }
      }
      that.changeState('secondSignUp', datum);
      return;
    }
    // 同意した利用規約のバージョン番号を確認する
    const isLowVer = checkTermsVer(result, 'custom:agreed_term', TERM_VER, 'ver');
    if (isLowVer) {
      await Auth.signOut();
      const datum = {
        username: this.state.mailAddress,
        pw: this.state.paramPassword
      }
      this.userDataForCheckTerm = datum;
      this.setState({
        termVerError: true
      });
      return;
    }
    this.setState({
      delivery: null,
      paramPassword:"",
      mailAddress: "",
      passState: {
        isNumOk: false,
        isLowerOk: false,
        isUpperOk: false,
        isOverOk: false,
      }
    });
    const urlStr = SESSION_INIT_URL+"?client_id="+authConfig.userPoolWebClientId+"&refresh_token="+user.signInUserSession.refreshToken.token;
    const config = {
      headers: {
        'Content-Type': 'plain/text',
      },
      withCredentials: true,
    };
    try {
      await axios.get(urlStr, config);
    } catch (err) {
      console.log('err :: makeSession');
      console.log(err);
    }
    this.changeState('signedIn', user);
  }

  sendView() {
    const theme = this.props.theme || AmplifyTheme;
    return (
      <div className="textLeft">
      <p className="loginFlowText">{I18n.get('Enter your registered ID (mail address). You can receive an mail to reset your password.')}</p>
      <label className="loginLabel">{I18n.get('Mail')}</label>
        <InputRow
          autoFocus
          placeholder={I18n.get('Username')}
          theme={theme}
          key="username"
          name="username"
          onChange={this.handleInputChange}
        />
        <p className='errorText'>{this.state.errorStr}</p>
        <div className="confirmCode">
          <ButtonRow style={theme.loginLargeButton} theme={theme} onClick={this.send} disabled={this.isSendCodeDisabled}>
            {I18n.get('Send Code')}
          </ButtonRow>
        </div>
      </div>
    )
  }

  toggleDisabled = (param) => {
    this.setState({
      isDisabled : param,
    });
  }
  setPassword = (param) => {
    this.setState({
      paramPassword:param,
    });
  }
  setPassState = (param) => {
    this.setState({
      passState:param,
    });
  }
  submitView() {
    const theme = this.props.theme || AmplifyTheme;
    return (
      <div className="textLeft">
        <div className="loginFlowText">
          <MessageRow>{this.state.mailAddress}</MessageRow>
          <MessageRow>{I18n.get('The Verification Code was sent. Enter the 6 digit verification code described in the mail body and send it.')}</MessageRow>
        </div>
        <label className="loginLabel">{I18n.get('Code')}</label>
        <InputRow
          placeholder={I18n.get('Code')}
          theme={theme}
          key="code"
          name="code"
          autoComplete="off"
          onChange={this.handleInputChange}
        />
        <p className='errorText'>{this.state.codeErrorStr}</p>
        <EnterPassword
          theme={theme}
          toggleDisabled={this.toggleDisabled}
          setPassword={this.setPassword}
          setPassState={this.setPassState}
          passState={this.state.passState}
          confirmCode={this.inputs.code}
        />
        { this.state.delivery? this.passStateView() : <div /> }
        <div className="confirmCode">
          <ButtonRow style={theme.loginLargeButton} theme={theme} onClick={() => this.submit(this)} disabled={this.state.isDisabled}>
            {I18n.get('Submit')}
          </ButtonRow>
        </div>
        <div className="loginForgetpass loginCodecheckFooter textLeft">
          <p className="fontSizeSmall">{I18n.get('If you can not receive verification code, you can try to resend.')}<br />
            <Link theme={theme} onClick={() => this.send()}>{I18n.get('Resend Code')}</Link>
          </p>
          {getHrefByLocaleLaplaceidQa(theme)}
        </div>
      </div>
    )
  }
  passStateView() {
    let numStyle = errorColor;
    let lowerStyle = errorColor;
    let upperStyle = errorColor;
    let isOverStyle = errorColor;
    if (this.state.passState.isNumOk) {
      numStyle = okColor;
    } else {
      numStyle = errorColor;
    }
    if (this.state.passState.isLowerOk) {
      lowerStyle = okColor;
    } else {
      lowerStyle = errorColor;
    }
    if (this.state.passState.isUpperOk) {
      upperStyle = okColor;
    } else {
      upperStyle = errorColor;
    }
    if (this.state.passState.isOverOk) {
      isOverStyle = okColor;
    } else {
      isOverStyle = errorColor;
    }

    return (
      <div className="loginPassConditions">
        <p className="colNatural01">{I18n.get('Password strength is required belows')}</p>
        <ul>
          <li style={numStyle}>{I18n.get('Require numbers')}</li>
          <li style={lowerStyle}>{I18n.get('Require lowercase letters')}</li>
          <li style={upperStyle}>{I18n.get('Require uppercase letters')}</li>
          <li style={isOverStyle}>{I18n.get('8 letters more over')}</li>
        </ul>
      </div>
    )
  }

  checkUsername = () => {
    if (this.inputs.username === '') {
      this.isSendCodeDisabled = true;
      return false;
    } if (this.inputs.username.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      this.isSendCodeDisabled = false;
      return false;
    } else {
      this.isSendCodeDisabled = true;
      return true;
    }
  }
  validateConfirmCode = () => {
    let buttonState = this.isDisabled;
    let errorStr = "";
    if (this.inputs.code.match(/([^0-9])+/)) {
      buttonState = true;
      errorStr = I18n.get('Invalid verification code provided, please try again.');
    } else if (this.inputs.code === '') {
      buttonState = true;
    } else if (this.state.paramPassword === ''){
      buttonState = true;
    } else {
      buttonState = false;
    }
    this.setState({
      codeErrorStr : errorStr,
      isDisabled : buttonState,
    });
  }
  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value } = evt.target;
    this.inputs[name] = value;
    if (name === "username") {
      if (this.checkUsername()) {
        this.setState({
          "mailAddress":"",
          errorStr:I18n.get('Mail address style is not valid.')
        });
        return;
      }
      this.setState({
        "mailAddress":value,
        errorStr : ""
      });
    } else if (name === "code") {
      this.validateConfirmCode();
    }
  }
  back = () => {
    this.setState({
      delivery: null,
      isDisabled : true,
      paramPassword:"",
      mailAddress: "",
      passState: {
        isNumOk: false,
        isLowerOk: false,
        isUpperOk: false,
        isOverOk: false,
      }
    });
    this.changeState('signIn');
  }
  async closeTermVerError (that) {
    that.changeState('reagreeTermsDocs', this.userDataForCheckTerm);
    this.setState({
      termVerError: false
    });
    return;
  }
  showComponent(theme) {
    return (
      <div className="loginContainer">
        <LogoArea theme={theme} />
        <FormSection theme={theme}>
          <SectionHeader theme={theme}>{I18n.get('Forgot Password')}</SectionHeader>
          <SectionBody>
            { this.state.delivery? this.submitView() : this.sendView() }
          </SectionBody>
          <SectionFooter theme={theme}>
          </SectionFooter>
        </FormSection>
        <LapDialog contentText={I18n.get('You will receive the verification code. Please enter the verification code described in the mail body.')} open={this.state.open} toClose={this.toClose} />
        <LapDialog contentText={this.state.resendErrStr} open={this.state.resendErrOpen} toClose={this.resendErrOpenClose} />
        <LapDialog
          title={''}
          contentElem={
            <div>
              <p>{I18n.get('Terms of Service is updated.')}</p>
              <p>{I18n.get('Please reconfirm it.')}</p>
            </div>
          }
          firstButtonText={'OK'}
          firstButtonFunc={() => this.closeTermVerError(this)}
          open={this.state.termVerError}
          toClose={() => {return;}}
        />
      </div>
    )
  }
}
